<template>
  <Button v-if="storeUrl" :href="loginUrl" tag="a" full-width>
    Continue with Google
  </Button>
</template>

<script>
import Button from "@/components/Button.vue";
export default {
  name: "GoogleSignOn",
  components: {
    Button,
  },
  data() {
    return {
      storeUrl: process.env.SHOPIFY_SSO_STORE_URL || null,
    };
  },
  computed: {
    loginUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      const returnUrl = params["checkout_url"] || params["return_url"];

      let redirectUrl = window.location.origin + "/account/login";
      if (returnUrl) {
        redirectUrl =
          window.location.origin + "/account/login?return_url=" + returnUrl;
      }

      const encodedRedirectUrl = encodeURI(redirectUrl);

      return `https://login.ratandboa.com/moas/broker/login/shopify/${this.storeUrl}/account?idpname=google_oauth&redirect_endpoint=${encodedRedirectUrl}`;
    },
  },
};
</script>
